import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import DataTableComponent from '../../common/DataTable/PrimeDataTable'; // Import the generic DataTable
import DeleteModal from '../../common/DeleteModal';
import ActivateDeactivateModal from '../../common/ActivateDeactivateModal';

const RoleList = ({ persona }) => {
  const [t] = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState({ open: false, record: null });
  const [confirmActivateModal, setConfirmActivateModal] = useState({ open: false, record: null });
  const navigate = useNavigate();
  const [paginationParams, setPaginationParams] = useState({
    limit: 10,
    offset: 0,
    sortField: 'createdAt',
    sortOrder: -1,
    filters: {}
  });

  const fetchRoles = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/roles`, { withCredentials: true }, {
        params: paginationParams
      }).catch((err) => {
        console.log(err);
      });

      setData(response?.data || []);
    } catch (error) {
      console.error('Error fetching roles:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, [persona, paginationParams]);

  const onDataTableEvent = (event) => {
    setPaginationParams(prev => ({
      ...prev,
      limit: event.rows,
      offset: event.first,
      sortField: event.sortField || prev.sortField,
      sortOrder: event.sortOrder || prev.sortOrder
    }));
  };

  const columns = [
    { field: 'id', header: t('ID'), sortable: true },
    { field: 'name', header: t('Name'), sortable: true },
    { field: 'createdAt', header: t('Created At'), sortable: true, body: (rowData) => new Date(rowData.createdAt).toLocaleString('en-GB') },
  ];

  const actions = [
    // { text: "View", color: 'primary', onClick: (row) => navigate(`/${persona}/roles/details/${row.id}`) },
    { text: "Edit", color: "secondary", onClick: (row) => navigate(`/${persona}/roles/edit/${row.id}`) },
    // { text: "Delete", onClick: (row) => setConfirmDeleteModal({ open: true, record: row }), color: "primary", status: 'danger' },
    { text: 'Activate / Deactivate', onClick: (row) => setConfirmActivateModal({ open: true, record: row }), color: "primary" ,status:"success"}
  ];

  return (
    <div>
      <DataTableComponent
        data={data}
        columns={columns}
        loading={loading}
        paginationParams={paginationParams}
        totalRecords={data?.length}
        onDataTableEvent={onDataTableEvent}
        enableCreate={true}
        enablePagination={true}
        enableLazyLoading={false}
        enableExport={true}
        actions={actions}
        sectionName={"Roles"}
      />

      {confirmDeleteModal && (
        <DeleteModal
          sentData={confirmDeleteModal.record}
          onEvent={setConfirmDeleteModal}
          onConfirm={fetchRoles}
          apiPath="roles"
          axios={axiosInstance}
          columnName="name"
        />
      )}

      {confirmActivateModal.open && (
        <ActivateDeactivateModal
          sentData={confirmActivateModal.record}
          onEvent={setConfirmActivateModal}
          onConfirm={fetchRoles}
          apiPath="roles"
          axios={axiosInstance}
          columnName="name"
          dbAction="active"
        />
      )}
    </div>
  );
};

export default RoleList;
